import React from 'react';
import { motion } from 'framer-motion';
import { Search, Bell } from 'lucide-react';
import ThemeToggle from '../ThemeToggle';

const LayoutHeader: React.FC = () => {
  return (
    <header className="glass border-b border-slate-200/60 dark:border-slate-800/60 px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Page Context */}
        <div className="flex items-center space-x-4">
          <div className="text-slate-500 dark:text-slate-400">
            <span className="text-sm font-medium">DNS Management</span>
          </div>
        </div>

        {/* Global Search and Actions */}
        <div className="flex items-center space-x-4">
          {/* Global Search */}
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search zones, records..."
              className="pl-10 pr-4 py-2 w-80 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
            />
          </div>

          {/* Notifications */}
          <motion.button
            className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors relative"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Bell className="w-5 h-5" />
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
          </motion.button>

          {/* Theme Toggle */}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};

export default LayoutHeader;